import * as React from 'react';
import Merchant from '../../../../domain/entities/Merchant';
import MerchantStation from '../../../../domain/entities/MerchantStation';
import FavoriteButton from '../../../common/buttons/FavoriteButton';
import StarRating, { StarRatingSize } from '../../../common/icons/StarRating';
import Tag, { TagColor } from '../../../common/tags/Tag';
import css from './ExploreMerchantCard.module.scss';

interface Props {
  merchant: Merchant;
  merchantStations: MerchantStation[];
  isFavorite: boolean;
}

class ExploreMerchantCard extends React.PureComponent<Props> {
  public static defaultProps: Partial<Props> = {
    isFavorite: true,
  };

  public render() {
    const { merchant, merchantStations, isFavorite } = this.props;

    return (
      <div className={css.ExploreMerchantCard}>
        <a href={`/${merchant.publicId}`}>
          <div
            className={css.ExploreMerchantCard__Head}
            style={{ backgroundImage: `url(${merchant.coverImage.url})` }}
          />
          <div className={css.ExploreMerchantCard__Body}>
            <div className={css.ExploreMerchantCard__Heading}>
              {merchant.displayName}
            </div>
            <div className={css.ExploreMerchantCard__Details}>
              <div>
                <div className={css.ExploreMerchantCard__Areas}>
                  {merchant.area ? merchant.area.localName : ''}
                </div>
                <div className={css.ExploreMerchantCard__Rating}>
                  <span>
                    <StarRating
                      rate={merchant.rating.average}
                      size={StarRatingSize.Medium}
                    />
                  </span>
                  <span className={css.ExploreMerchantCard__RatingAvg}>
                    {merchant.rating.average}
                  </span>
                  <span>({merchant.rating.totalCount})</span>
                </div>
              </div>
              <div>
                <FavoriteButton
                  count={merchant.favoriteCount}
                  isFavorite={isFavorite}
                />
              </div>
            </div>
            <div className={css.ExploreMerchantCard__Stations}>
              {merchantStations.slice(0, 4).map((station, i) => (
                <Tag color={TagColor.Station} key={i}>
                  {station.name + '駅 '}
                  {station.walkingTime > 0
                    ? `徒歩${station.walkingTime}分`
                    : Math.round((station.distance / 1000) * 10) / 10 + 'km'}
                </Tag>
              ))}
            </div>
          </div>
        </a>
      </div>
    );
  }
}

export default ExploreMerchantCard;
